<div class="container-fluid">
	<div class="row flex-nowrap">

		<div id="menu-panel" class="col-auto d-none d-md-block">

			<div class="menu-header text-center">
				<i class="fa fa-4x fa-store-alt page-icon"></i>
			</div>

			<div>
				<button class="btn btn-primary pl-3 pr-3" onclick="Anvil.page.refresh()"><i class="fa fa-lg mb-2 fa-sync-alt"></i><br />Frissítés</button>
				<hr />

				<a class="btn btn-dark pl-3 pr-3 mb-2" href="https://dbserver01.webdisk.hu:8010/phpmyadmin/index.php?route=/database/structure&db=c1_cstore_<%- site.company_db_name %>" target="_blank"><i class="fa fa-server text-success mb-2"></i><br />Adatbázis</a><br />
				<button class="btn btn-dark pl-3 pr-3" onclick="Anvil.page.sign_in_to_cloud('<%- site.company_db_name %>')"><i class="fa fa-cloud text-success mb-2"></i><br />Felhő</button>
				<hr />

				<button class="btn btn-dark pl-3 pr-3 mb-2" onclick="Anvil.page.openSite()"><i class="fa fa-map-marked-alt text-light mb-2"></i><br />Telephely</button><br />
				<button class="btn btn-dark pl-3 pr-3" onclick="Anvil.page.openOpeningHours()"><i class="fa fa-clock text-light mb-2"></i><br />Nyitvatartás</button>

				<hr />
				<div class="alert bg-dark p-2">
					DB: <%= site.company_db_name %><br />
					SITE: <%= site.id %><br />
					STORAGE: <%= storage.id %>
				</div>
			</div>
		</div>

		<div class="col list-panel">

			<div class="row">
				<div class="col">

					<div class="page-header">

						<ol class="breadcrumb mb-2">
							<li class="breadcrumb-item"><%= site.company_name %></li>
							<li class="breadcrumb-item"><%- (storage.ntak_cert ? storage.ntak_cert.regnumber : '<span class="text-danger">NINCS TANÚSÍTVÁNY</span>') %> (<%= year %>)</li>
						</ol>

						<div class="float-end">
							<div class="row g-2">
								<div class="col-auto d-none d-lg-block" style="width:430px;">
									<%- include('/ui/form', {
										params: [ 'search1', search_form ],
										fields: [
											{
												type: 'select',
												inline: true,
												name: 'place_id',
												title: 'Cég / Telephely / Raktár',
												params: {
													maxItems: 1,
													options: Anvil.page.places,
													valueField: 'id',
													labelField: 'storage_name',
													searchField: [ 'company_name', 'company_tax_number', 'site_name', 'storage_regnumber' ],
													render: {
														item: (item, esc) => `<div>${esc(item.company_name.substring(0, 30))} - ${esc(item.site_name)}</div>`,
														option: (item, esc) => {
															return `
															<div class="option">
																<div class="row g-1">
																	<div class="col">
																		${esc(item.company_name)}<br />
																		<small>${esc(item.company_tax_number)}</small>
																	</div>
																	<div class="col">
																		${esc(item.site_name)}<br />
																		<small>${esc(item.storage_regnumber)}</small>
																	</div>
																</div>
															</div>`
														}
													}
												},
												prepend: '<span class="input-group-text"><i class="fa fa-map-marker"></i></span>',
												update: (value) => {
													if (!value) return
													const [ db_name, storage_id] = value.split('_')
													Anvil.route(Anvil.href('/c_order/storage/calendar', {
														db_name: db_name,
														storage_id: storage_id,
														year: Anvil.page.year
													}))
												}
											}
										]
									}) %>
								</div>
								<div class="col-auto d-none d-lg-block" style="width:120px;">
									<%- include('/ui/form', {
										params: [ 'search2', search_form ],
										fields: [
											{
												type: 'select',
												inline: true,
												name: 'year',
												title: 'Év',
												params: {
													maxItems: 1,
													options: (() => {
														const currentYear = new Date().getFullYear()
														const options = []
														for (let year = 2023; year <= currentYear; year++) {
															options.push({ value: year.toString(), name: year.toString() })
														}
														return options
													})(),
													valueField: 'value',
													labelField: 'name',
												},
												prepend: '<span class="input-group-text"><i class="fa fa-calendar"></i></span>',
												update: (value) => {
													Anvil.route(Anvil.href('/c_order/storage/calendar', {
														db_name: Anvil.page.db_name,
														storage_id: Anvil.page.storage_id,
														year: value
													}))
												}
											}
										]
									}) %>
								</div>
								<div class="col-auto d-lg-block" style="width:270px;">
									<%- include('/ui/form', {
										params: [ 'search3', search_form ],
										fields: [
											{
												type: 'select',
												inline: true,
												name: 'view',
												title: 'Nézet',
												params: {
													maxItems: 1,
													options: [

														// Naptári napok
														{ value: 'orders' , name: 'Rendelések', group: 'calendar_day' },
														{ value: 'avg-order-value' , name: 'Átlagos kosárérték', group: 'calendar_day' },
														{ value: 'turnover' , name: 'Bevétel (bizonylatok)', group: 'calendar_day' },
														{ value: 'turnover-cash' , name: 'Bevétel - Készpénz', group: 'calendar_day' },
														{ value: 'turnover-card' , name: 'Bevétel - Kártya', group: 'calendar_day' },
														{ value: 'turnover-credit-card' , name: 'Bevétel - Bankkártya', group: 'calendar_day' },
														{ value: 'turnover-szep-card' , name: 'Bevétel - SZÉP kártya', group: 'calendar_day' },
														{ value: 'turnover-other' , name: 'Bevétel - Egyéb', group: 'calendar_day' },

														// NTAK Üzleti napok
														{ value: 'reports' , name: 'Tárgynapi jelentések', group: 'ntak_day' },
														{ value: 'time' , name: 'Tárgynapi rendelési időszak', group: 'ntak_day' },
														{ value: 'sd-turnover' , name: 'Tárgynapi forgalom', group: 'ntak_day' }
													],
													optgroups: [
														{ value: 'calendar_day', label: 'Naptári napok' },
														{ value: 'ntak_day', label: 'Tárgynapok (NTAK)' }
													],
													optgroupField: 'group',
													valueField: 'value',
													labelField: 'name',
												},
												prepend: '<span class="input-group-text"><i class="fa fa-eye"></i></span>',
												update: (value) => {
													$('#calendar-wrapper').toggleClass('view-orders', value == 'orders')
													$('#calendar-wrapper').toggleClass('view-avg-order-value', value == 'avg-order-value')
													$('#calendar-wrapper').toggleClass('view-turnover', value == 'turnover')
													$('#calendar-wrapper').toggleClass('view-turnover-cash', value == 'turnover-cash')
													$('#calendar-wrapper').toggleClass('view-turnover-card', value == 'turnover-card')
													$('#calendar-wrapper').toggleClass('view-turnover-credit-card', value == 'turnover-credit-card')
													$('#calendar-wrapper').toggleClass('view-turnover-szep-card', value == 'turnover-szep-card')
													$('#calendar-wrapper').toggleClass('view-turnover-other', value == 'turnover-other')

													$('#calendar-wrapper').toggleClass('view-reports', value == 'reports')
													$('#calendar-wrapper').toggleClass('view-time', value == 'time')
													$('#calendar-wrapper').toggleClass('view-sd-turnover', value == 'sd-turnover')

												}
											}
										]
									}) %>
								</div>
								<div class="col-auto d-lg-none">
									<button id="filter-btn-2" class="btn btn-dark position-relative" onclick="Anvil.page.searchModal()"><i class="fa fa-fw fa-filter"></i><span id="filter-btn-badge-2" class="badge rounded-pill bg-danger position-absolute top-0 start-100 translate-middle d-none"></span></button>
								</div>
							</div>
						</div>
						<h2 class="pt-1">Forgalmi betekintés</h2>
					</div>

					<div id="calendar-wrapper" class="view-reports" style="height:calc(100vh - 152px);">
						<div id="calendar"></div>
					</div>
				</div>
			</div>

		</div>

	</div>
</div>

<script>
Object.assign(Anvil.page, {

	init () {

		Anvil.page.calendar = new FullCalendar.Calendar(document.getElementById('calendar'), {

			themeSystem: 'bootstrap5',
			aspectRatio: 2.3,
			contentHeight: window.innerHeight - 152,
			windowResize: function(arg) {
				Anvil.page.calendar.setOption('contentHeight', window.innerHeight - 152);
  			},

			headerToolbar: false,
			locale: 'hu',
			firstDay: 1,

			initialView: 'multiMonthYear',
			initialDate: `${Anvil.page.year}-01-01`,
			multiMonthMinWidth: 300,
			multiMonthMaxColumns: 4,

			selectable: true,

			dateClick: function(info) {
				Anvil.page.openDay(info.dateStr)
			},

			events: (info, successCallback, failureCallback) => { successCallback(Anvil.page.events) },
			eventContent: (info) => {
				const raw = info.event._def.extendedProps
				const totals = Anvil.page.storage_calendar.data.totals
				//const icon = (raw.receipts && (parseInt(raw.reported_receipts) < parseInt(raw.receipts)))  ? '<i class="fa fa-times-circle text-danger"></i>' : '<i class="fa fa-check-circle text-success"></i>'
				const day_icon = raw.subject_day.type == 'NORMAL_NAP' ? '<i class="fa fa-plus-circle text-success"></i>' :
							raw.subject_day.type == 'FORGALOM_NELKULI_NAP' ? '<i class="fa fa-pause-circle text-secondary"></i>' :
							raw.subject_day.type == 'ADOTT_NAPON_ZARVA' ? '<i class="fa fa-door-closed text-secondary"></i>' :
							(raw.subject_day.type == 'NEM_JELENTETT' && raw.subject_day.day_reports.unsent > 0) ? '<i class="fa fa-cog fa-spin text-danger"></i>' :
							(raw.subject_day.type == 'NEM_JELENTETT' && raw.subject_day.day_reports.failed > 0) ? '<i class="fa fa-exclamation-circle text-danger"></i>' :
							(raw.subject_day.type == 'NEM_JELENTETT' && raw.subject_day.day_reports.unsent == 0) ? '<i class="fa fa-question-circle text-secondary"></i>' : ''

				const day_color =  raw.subject_day.type == 'NORMAL_NAP' ? 'hsl(100, 40%, 30%)' :
						raw.subject_day.type == 'FORGALOM_NELKULI_NAP' ? 'hsl(0, 0%, 30%)' :
						raw.subject_day.type == 'ADOTT_NAPON_ZARVA' ? 'hsl(0, 0%, 30%)' :
						(raw.subject_day.type == 'NEM_JELENTETT' && raw.subject_day.day_reports.unsent > 0) ? 'hsl(55, 75%, 60%)' :
						(raw.subject_day.type == 'NEM_JELENTETT' && raw.subject_day.day_reports.unsent == 0) ? 'hsl(0, 50%, 30%)' : 'black'

				// Naptári napi adatok
				const order_turnover = raw?.calendar_day?.orders?.turnover || '0'
				const order_shade = (raw?.calendar_day?.orders?.turnover > 0) ? Math.min(70, Math.round(order_turnover / totals.calendar_day.orders.max_turnover * 70)) + 10 : 0;
				const order_count = raw?.calendar_day?.orders?.count || '0'

				const avg_order_value = raw?.calendar_day?.avg_order || 0
				const avg_order_value_shade = (avg_order_value > 0 && totals.calendar_day.max_daily_avg_order > 0) ? Math.min(70, Math.round(avg_order_value / totals.calendar_day.max_daily_avg_order * 70)) + 10 : 0;

				const turnover = raw?.calendar_day?.receipts?.turnover || '0'
				const turnover_shade = (turnover > 0) ? Math.min(70, Math.round(turnover / totals.calendar_day.receipts.max_turnover * 70)) + 10 : 0;
				const receipt_count = raw?.calendar_day?.receipts?.count || '0'

				const turnover_cash = raw?.calendar_day?.receipts?.turnover_cash || 0
				const turnover_cash_shade = (turnover_cash > 0) ? Math.min(70, Math.round(turnover_cash / totals.calendar_day.receipts.max_turnover * 70)) + 10 : 0;

				const turnover_card = raw?.calendar_day?.receipts?.turnover_card || 0
				const turnover_card_shade = (turnover_card > 0) ? Math.min(70, Math.round(turnover_card / totals.calendar_day.receipts.max_turnover * 70)) + 10 : 0;

				const turnover_credit_card = raw?.calendar_day?.receipts?.turnover_credit_card || 0
				const turnover_credit_card_shade = (turnover_credit_card > 0) ? Math.min(70, Math.round(turnover_credit_card / totals.calendar_day.receipts.max_turnover * 70)) + 10 : 0;

				const turnover_szep_card = raw?.calendar_day?.receipts?.turnover_szep_card || 0
				const turnover_szep_card_shade = (turnover_szep_card > 0) ? Math.min(70, Math.round(turnover_szep_card / totals.calendar_day.receipts.max_turnover * 70)) + 10 : 0;

				const turnover_other = raw?.calendar_day?.receipts?.turnover_other || 0
				const turnover_other_shade = (turnover_other > 0) ? Math.min(70, Math.round(turnover_other / totals.calendar_day.receipts.max_turnover * 70)) + 10 : 0;

				// Tárgynapi adatok
				const sd_turnover = raw?.subject_day?.turnover || 0
				const sd_turnover_shade = (sd_turnover > 0) ? Math.min(70, Math.round(sd_turnover / totals.subject_day.max_turnover * 70)) + 10 : 0;

				const first_t = raw.subject_day.first_receipt_t ? Anvil.moment(raw.subject_day.first_receipt_t).format('HH:mm') : ''
				const last_t = raw.subject_day.last_receipt_t ? Anvil.moment(raw.subject_day.last_receipt_t).format('HH:mm') : ''

				return {
					html: `
						<div class="cv-orders" style="background:hsl(180deg 65% ${order_shade}%); color:hsl(35deg 100% ${order_shade > 40 ? 20 : 80}%);">
							${Anvil.numeral(order_turnover).format('0,0')}<br />
							<div class="cv-percentage">${order_count}</div>
						</div>
						<div class="cv-avg-order-value" style="background:hsl(180deg 65% ${avg_order_value_shade}%); color:hsl(35deg 100% ${avg_order_value_shade > 40 ? 20 : 80}%);">
							${Anvil.numeral(avg_order_value).format('0,0')}
						</div>
						<div class="cv-turnover" style="background:hsl(180deg 65% ${turnover_shade}%); color:hsl(35deg 100% ${turnover_shade > 40 ? 20 : 80}%);">
							${turnover ? Anvil.numeral(turnover).format('0,0') : '-'}
							<div class="cv-percentage">${receipt_count}</div>
						</div>
						<div class="cv-turnover-cash" style="background:hsl(180deg 65% ${turnover_cash_shade}%); color:hsl(35deg 100% ${turnover_cash_shade > 40 ? 20 : 80}%);">
							${turnover_cash ? Anvil.numeral(turnover_cash).format('0,0') : '-'}<br />
							<div class="cv-percentage">${turnover_cash ? Anvil.numeral(turnover_cash / turnover).format('0,0%') : ''}</div>
						</div>
						<div class="cv-turnover-card" style="background:hsl(180deg 65% ${turnover_card_shade}%); color:hsl(35deg 100% ${turnover_card_shade > 40 ? 20 : 80}%);">
							${turnover_card ? Anvil.numeral(turnover_card).format('0,0') : '-'}<br />
							<div class="cv-percentage">${turnover_card ? Anvil.numeral(turnover_card / turnover).format('0,0%') : ''}</div>
						</div>
						<div class="cv-turnover-credit-card" style="background:hsl(180deg 65% ${turnover_credit_card_shade}%); color:hsl(35deg 100% ${turnover_credit_card_shade > 40 ? 20 : 80}%);">
							${turnover_credit_card ? Anvil.numeral(turnover_credit_card).format('0,0') : '-'}<br />
							<div class="cv-percentage">${turnover_credit_card ? Anvil.numeral(turnover_credit_card / turnover).format('0,0%') : ''}</div>
						</div>
						<div class="cv-turnover-szep-card" style="background:hsl(180deg 65% ${turnover_szep_card_shade}%); color:hsl(35deg 100% ${turnover_szep_card_shade > 40 ? 20 : 80}%);">
							${turnover_szep_card ? Anvil.numeral(turnover_szep_card).format('0,0') : '-'}<br />
							<div class="cv-percentage">${turnover_szep_card ? Anvil.numeral(turnover_szep_card / turnover).format('0,0%') : ''}</div>
						</div>
						<div class="cv-turnover-other" style="background:hsl(180deg 65% ${turnover_other_shade}%); color:hsl(35deg 100% ${turnover_other_shade > 40 ? 20 : 80}%);">
							${turnover_other ? Anvil.numeral(turnover_other).format('0,0') : '-'}<br />
							<div class="cv-percentage">${turnover_other ? Anvil.numeral(turnover_other / turnover).format('0,0%') : ''}</div>
						</div>

						<div class="cv-reports" style="background:${day_color};">
							<span class="float-start">${day_icon}</span>
							${raw.subject_day.receipts.submitted > 0 ? `<span class="${raw.subject_day.receipts.submitted < raw.subject_day.receipts.total ? 'text-warning' : 'text-success'}">${raw.subject_day.receipts.submitted}/${raw.subject_day.receipts.total}</span>` : '&nbsp;'}
							<div class="cv-percentage">
								${raw.subject_day.receipts.unsent > 0 ? `<span class="text-warning"><i class="fa fa-fw fa-cog fa-spin"></i>${raw.subject_day.receipts.unsent}</span>` : ''}
								${raw.subject_day.receipts.failed > 0 ? `<span class="text-danger"><i class="fa fa-fw fa-exclamation-circle"></i>${raw.subject_day.receipts.failed}</span>` : ''}
							</div>
						</div>
						<div class="cv-time">
							${first_t ? first_t : ''}<br />
							${last_t ? last_t : ''}
						</div>
						<div class="cv-sd-turnover" style="background:hsl(180deg 65% ${sd_turnover_shade}%); color:hsl(35deg 100% ${sd_turnover_shade > 40 ? 20 : 80}%);">
							${Anvil.numeral(sd_turnover).format('0,0')}<br />
							<div class="cv-percentage">${raw.subject_day.receipts.total}</div>
						</div>
					`
				}
			}
		})

        Anvil.page.calendar.render()
	},

	refresh () {
		Anvil.exec('c_order/storage/action_refresh_calendar')
	},

	openDay (day) {
		Anvil.exec('c_order/storage/modal_day', { day })
	},

	openSite () {
		Anvil.exec('c_order/site/modal_edit', Anvil.page.company_db.id, Anvil.page.site.id)
	},

	openOpeningHours () {
		Anvil.exec('c_order/storage/modal_opening_hours', Anvil.page.company_db.id, Anvil.page.storage.id)
	},

	async sign_in_to_cloud (db_name) {
		const token = await Anvil.exec('c_order/company_db/action_get_sign_in_token', db_name)
		if (token) {
			window.open(`https://ugyfel.c-store.eu/sys_login_1.html?CEGID=${db_name}&logintoken=${token}`, '_blank')
		}
	},

	destroy () {
		console.log('destroy')
	}
})
</script>
